"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  vscLog: {
    shipSynchronization: '船岸同步',
    shipCommunication: '船舶通讯配置',
    vesselId: '船舶',
    commStatus: '船舶状态',
    pleaseSelect: '请选择',
    vesselCnName: '船名',
    email: '邮箱',
    operation: '操作',
    dataEmail: '数据邮箱',
    passwd2: '数据重发',
    email2: '附件重发',
    pleaseEnter: '请输入',
    passwd: '密码',
    haveImplemented: '已实施',
    unimplemented: '未实施',
    notEmpty: '不能为空',
    selectStatus: '请选择状态',
    shipExisting: '船舶已存在!',
    searchFailed: '搜索失败',
    saveSuccessfully: '保存成功',
    updateSuccessfully: '更新成功',
    deleteData: '确定删除该条数据吗',
    reminder: '提示',
    yes: '是',
    no: '否',
    successfullyDelete: '删除成功',
    synchronousTable: '同步表配置',
    tableName: '数据表名',
    pleaseEnterContent: '请输入内容',
    modelName: '对象名称',
    syncFlag: '是否同步',
    syncByCompanyFlag: '相关附件是否按公司同步',
    tableN: '表名',
    tableChineseName: '表中文名',
    modelN: '对象名',
    modelParser: '对象解析器',
    syncVesselField: '船舶字段',
    packageClassName: '包名.类名',
    syncVesselCondition: '岸端条件',
    elExpression: 'el表达式，满足才同步到船',
    elExpressionVessel: 'el表达式，满足才同步到岸',
    syncShoreCondition: '船端条件',
    syncVesselSql: '同步船舶sql',
    alreadyExist: '表名或对象名已存在!',
    synchronousFile: '同步文件监控',
    vesselCode: '船舶代码',
    fileName: '文件名',
    logType: '日志类型',
    logFileStatus: '执行状态',
    sendLogDtmFrom: '发送数据时间',
    selectDate: '选择日期',
    sendLogDtmTo: '到',
    receiveLogDtmFrom: '接收数据时间',
    serialNo: '邮件序列号',
    entityName: '表名',
    ddlType: '操作类型',
    entityId: '主键ID',
    entityData: '数据内容',
    sendData: '发送内容',
    fileSize: '文件大小',
    entityType: '类型',
    sendFlag: '是否发送',
    sendLog: '发送日志',
    receivingLog: '接收日志',
    resendLog: '重发日志',
    nonExecution: '未执行',
    sentEmails: '已发送',
    synchronousSuccess: '同步成功',
    synchronizationFailure: '同步失败',
    watch: '表',
    object: '对象',
    newlyIncreased: '新增',
    unsent: '未发送',
    delete: '删除',
    revamp: '修改',
    defeated: '失败',
    advanceTo: '成功执行',
    synchronousAttachment: '同步附件监控',
    attachmentName: '附件名',
    attachmentSize: '附件大小',
    createTime: '发送时间',
    xeecuteSuccessfully: '执行成功',
    filter: '过滤器',
    keyword: '文件名',
    packetRetransmission: '数据包重发',
    attachmentFileId: '附件ID',
    referenceId: '业务主键',
    referenceTable: '业务表名',
    selectToSend: '请选中一条要发送的记录',
    sendSuccessfully: '发送成功',
    waitingSent: '数据包等待发送中',
    sendLogDtm: '发送数据日期',
    receiveLogDtm: '接收回执日期',
    errorMessage: '错误日志',
    resendSuccess: '重发成功',
    executedSuccessfully: '数据已成功执行',
    vesselName: '船舶名称',
    isUpdated: '是否升级',
    all: '全部',
    unDone: '未执行',
    updateSuccess: '升级成功',
    updateFail: '升级失败',
    vesselUpdate: '船端升级',
    syncData: '数据同步',
    syncVessel: '同步到船',
    syncShore: '同步到岸',
    reExecute: '重新执行',
    executeSuccess: '执行成功',
    executeFail: '执行失败',
    selectToReExecute: '请选择一条重新执行',
    reExecutePrompt: '必须选择一条执行失败的记录',
    lastModifyTime: '修改时间'
  }
};